import styled from "styled-components";
import {CharcoalBlack, DarkSlate, ErrorRed, Silver, Teal, White} from "../../../../theme/variable";
import {media} from "../../../../theme/responsive.js";

export const RadioButtonField = styled.div`
    display: inline-block;
    margin-bottom: 20px;
    margin-right: 16px;
    vertical-align: middle;
    outline: none;
    &:last-child {
        margin-right: 0;
        // & input:checked:after {
        //     left: 48%;
        // }
    }
`;

export const RadioButtonLabel = styled.label`
    position: relative;
    cursor: pointer;
    font-size: 0.9375rem;
    line-height: 24px;
    vertical-align: middle;
    color: ${(props) => (props.disabled ? `${Silver}` : `${CharcoalBlack}`)};
    &:after {
        content: "";
        opacity: 0;
        transform: scale(0);
    }
`;
export const Input = styled.input`
    padding: 0;
    height: initial;
    width: initial;
    margin-bottom: 0;
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;
    background-color: transparent;
    border: ${(props) => {
        if (props.disabled) {
            return `1.5px solid ${Silver}`;
        } else {
            if (props.checked || props.isFocused) return `1.5px solid ${Teal}`;
            if (props.isError) return `1.5px solid ${ErrorRed}`;
        }
        return `1.5px solid ${DarkSlate};`;
    }};
    background: ${White};
    width: 16px;
    height: 16px;
    border-radius: 2px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 6px;
    top: -1px;
    border-radius: 50%;

    &:focus {
        border: 1.5px solid ${Teal};
    }
    &:checked + ${RadioButtonLabel}:before {
        background: ${White};
        border: ${(props) => {
            if (props.disabled) {
                return `1.5px solid ${Silver}`;
            } else {
                if (props.checked) return `1.5px solid ${Teal}`;
            }
            return `1.5px solid ${DarkSlate};`;
        }};
    }
    &:checked:after {
        content: "";
        display: block;
        width: 9px;
        height: 9px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: ${(props) => (props.disabled ? `${Silver}` : `${Teal}`)};
        border-radius: 50%;
        opacity: 1;
        transform: scale(1);
        outline: none;
        transition: opacity 80ms 0ms cubic-bezier(0.4, 0, 0.6, 1),
            transform 80ms 0ms cubic-bezier(0.4, 0, 0.6, 1);
        transform: translate(-50%, -50%);
        // ${media.laptop`left: 46%;`}
    }
`;
